import { createContext, useContext, useState, type ReactNode } from 'react';

interface SelectedHouseholdContextValue {
  selectedId: string;
  setSelectedId: (id: string) => void;
}

const SelectedHouseholdContext = createContext<SelectedHouseholdContextValue>({
  selectedId: '',
  setSelectedId: () => {},
});

export function SelectedHouseholdProvider({ children }: { children: ReactNode }) {
  const [selectedId, setSelectedId] = useState('');
  return (
    <SelectedHouseholdContext.Provider value={{ selectedId, setSelectedId }}>
      {children}
    </SelectedHouseholdContext.Provider>
  );
}

export function useSelectedHouseholdContext() {
  return useContext(SelectedHouseholdContext);
}
